<template>
  <div>
    <a-table
      :columns="columns"
      :data-source="form.publicAttachement"
      rowKey="id"
      :pagination="false"
      tableLayout="fixed"
    >

      <!-- 附件信息列 -->
      <template slot="file" slot-scope="text, record">
        <div class="file-cell-wrapper">

          <a-upload
            class="upload-wrapper"
            :file-list="getFileList(record)"
            :showUploadList="{ showRemoveIcon: true }"
            :customRequest="(f) => uploadFile(f, record)"
            :remove="(file) => removeFile(file, record)"
            :multiple="true"
          >
            <!-- 无附件时显示 -->
            <span
              v-if="!(record.files && record.files.length > 0)"
              class="upload-link"
            >
              请上传附件
            </span>
          </a-upload>

        </div>
      </template>

      <!-- 状态列 -->
      <template slot="status" slot-scope="text, record">
        <span v-if="record.files && record.files.length > 0" class="success">
          已上传（{{ record.files.length }} 个）
        </span>
        <span v-else class="warning">未上传</span>
      </template>

      <!-- 操作列 -->
      <template slot="action" slot-scope="text, record">
        <a-upload
          :showUploadList="false"
          :customRequest="(f) => uploadFile(f, record)"
          :multiple="true"
        >
          <a-button type="default" size="small">
            <a-icon type="upload" />
            上传材料
          </a-button>
        </a-upload>
      </template>

    </a-table>
  </div>
</template>

<script>
export default {
  name: "PublicAttachmentPage",

  data() {
    return {
      form: {
        publicAttachement: [
          {
            id: 1,
            type: "其他公示的附件",
            files: []
          }
        ]
      },

      columns: [
        { title: "编号", dataIndex: "id", width: 80 },
        { title: "附件类型", dataIndex: "type", width: 260 },
        { title: "附件信息", dataIndex: "file", width: 450, scopedSlots: { customRender: "file" }},
        { title: "状态", dataIndex: "status", width: 140, scopedSlots: { customRender: "status" }},
        { title: "操作", dataIndex: "action", width: 140, scopedSlots: { customRender: "action" }}
      ]
    };
  },

  methods: {

    getFileList(row) {
      if (!row.files) return [];
      return row.files.map((f) => ({
        uid: f.uid,
        name: f.name,
        status: "done",
        url: f.url
      }));
    },

    // 上传文件
    async uploadFile(fileData, row) {
      const uid = fileData.file.uid;

      const res = await new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            data: "https://www.baidu.com"
          });
        }, 600);
      });

      if (!row.files) {
        this.$set(row, "files", []);
      }

      row.files.push({
        uid: uid,
        name: fileData.file.name,
        url: res.data
      });

      this.$message.success("上传成功");
    },

    removeFile(file, row) {
      if (!row.files) return true;

      row.files = row.files.filter((f) => f.uid !== file.uid);

      this.$message.success("文件已删除");
      return true;
    }
  }
};
</script>

<style scoped>
.upload-link {
  color: red;
}

.success {
  color: #52c41a;
}

.warning {
  color: #fa8c16;
}

/* ⭐ 让整格内容保持水平对齐，不上下偏移 */
.file-cell-wrapper {
  display: flex;
  align-items: center;       /* ⭐ 核心：保持文字/文件名同一水平线 */
  min-height: 32px;
}

/* ⭐ 让 Upload 自身不塌陷，并使内部 slot 居中 */
.upload-wrapper {
  display: flex !important;
  align-items: center;       /* ⭐ slot 内文本垂直居中 */
}

/* ⭐ 防止 Upload 自带的 fileList 出现/消失时高度跳动 */


/* ⭐ 超长文件名省略号 */
.file-cell-wrapper /deep/ .ant-upload-list-item-name {
  display: inline-block;
  max-width: 360px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
